import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import { getCurrencyLocaleValue } from "data/utils/formaters"

import styles from "./Asterisk.module.css"

const Asterisk = props => {
  const { t: translate } = useTranslate()
  const { minimalMonthlyChargeValue, lang } = props

  const minimalChargeFormatted = getCurrencyLocaleValue({
    currency: minimalMonthlyChargeValue.currency,
    value: minimalMonthlyChargeValue.value,
    language: lang,
  })

  return (
    <div className={styles.asteriskContainer}>
      {translate(
        "A minimum monthly charge of {value} is applied for Starter plan subscribers if the total value of success and transaction fees does not exceed this amount.",
        { value: minimalChargeFormatted }
      )}
    </div>
  )
}

Asterisk.propTypes = {
  minimalMonthlyChargeValue: PropTypes.object,
  lang: PropTypes.string.isRequired,
}
Asterisk.defaultProps = {
  minimalMonthlyChargeValue: { currency: "EUR", value: "12.99" },
}

export default Asterisk
